import { Alert } from '@mui/material';
import PropTypes from 'prop-types';

import BulkLotNdcReviewSkeleton from './BulkLotNdcReviewSkeleton';

/** Above this many selected items the dialog warns the fetch may take a moment. */
const LARGE_BATCH_THRESHOLD = 200;

/**
 * POM-6010 — what the Review Lot & NDC dialog shows before its grid can render.
 *
 * Split out of the dialog rather than inlined: the two states are mutually exclusive with the
 * grid and with each other, so keeping them here lets the dialog read as one branch instead of
 * three.
 */
const BulkLotNdcReviewLoadState = ({ loading, itemCount, loadError }) => {
  if (loading) {
    return (
      <>
        {itemCount > LARGE_BATCH_THRESHOLD && (
          <Alert severity='info' sx={{ mb: 2 }}>
            {`Large batch of ${itemCount} items — this may take a moment.`}
          </Alert>
        )}
        <BulkLotNdcReviewSkeleton itemCount={itemCount} />
      </>
    );
  }

  if (loadError) {
    return (
      <Alert severity='error' sx={{ mb: 2 }}>
        {loadError}
      </Alert>
    );
  }

  return null;
};

BulkLotNdcReviewLoadState.propTypes = {
  loading: PropTypes.bool,
  itemCount: PropTypes.number,
  loadError: PropTypes.string,
};

BulkLotNdcReviewLoadState.defaultProps = {
  loading: false,
  itemCount: 0,
  loadError: null,
};

export default BulkLotNdcReviewLoadState;
